import React, { useState, useEffect } from "react"
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import avatar from "assets/img/faces/ayo-ogunseinde-2.jpg";
import 'sweetalert2/src/sweetalert2.scss'
import rotas from '../../services/rotas'
import axios from 'axios'
import { Redirect } from 'react-router-dom'

// const formSwal      = withReactContent(Swal)
const form  = {
  usuario :sessionStorage.getItem('usuario'),
  cpf     :sessionStorage.getItem('cpf'),
  senha   :''
}

const AlertaLogin = async (props) => {

  Swal.fire({
    title: 'Sessão ou login expirado',
    html: `Usuário <b>${form.usuario}</b>.<br> Digite a senha para logar novamente.
    <input type="password" id="password" class="swal2-input" placeholder="Digite sua senha'">`,
    confirmButtonText: 'Logar',
    showCancelButton: true,
    cancelButtonText: 'Sair',
    focusConfirm: false,
    showLoaderOnConfirm: true,

    preConfirm: () => {
      form.senha = Swal.getPopup().querySelector('#password').value
      if (!form.senha) {
        Swal.showValidationMessage(`Por favor insira a senha`)
      }else{
        
        console.log(form)
        const url = rotas.login

        const logar = axios.post(url, form)
        return logar.then(ret => {
          console.log(ret.data)
          if(ret.data.erro === "sim"){
            Swal.showValidationMessage('Senha inválida !!')
          }else{
            sessionStorage.setItem('token', ret.data.token)
            sessionStorage.setItem('rede', ret.data.rede)
            sessionStorage.setItem('usuario', ret.data.usuario)
            sessionStorage.setItem('cpf', ret.data.cpf)
          }
        })

      }
    },
    allowOutsideClick: () => !Swal.isLoading()
  }).then((result) => {

    if (result.isConfirmed) {
      Swal.fire('Login efetuado com sucesso!', '','success')
    } else if (result.isDenied) {
      Swal.fire('erro no login!', '','error')
    } else if (result.dismiss) {
      sessionStorage.removeItem('token')
      console.log(props)
      return <Redirect to='/painelwebgestor/auth/login' />
    }

  })



//   formSwal.queue([{
//     title: 'Sessão expirada !',
//     input: 'password',
//     inputPlaceholder: 'Digite sua senha',
//     inputAttributes: {
//       maxlength: 10,
//       autocapitalize: 'off',
//       autocorrect: 'off'
//     },
//     html: usuario,
//     confirmButtonText: 'Logar',
//     showCancelButton: true,
//     text:'Digita sua senha para logar novamente.',
//     showLoaderOnConfirm: true,
//     cancelButtonColor: '#d33',
//     preConfirm: () => {
//       formSwal.fire('Salvo!', 'mensagem', 'success')
//     }
//   }])

// Swal.fire({  
//   title: 'Do you want to save the changes?',  
//   showDenyButton: true,  showCancelButton: true,  
//   confirmButtonText: `Save`,  
//   denyButtonText: `Don't save`,
// }).then((result) => {  
// 	/* Read more about isConfirmed, isDenied below */  
//     if (result.isConfirmed) {    
//     	Swal.fire('Saved! ops', '', 'success')  
//     } else {    
//     	Swal.fire('Changes are not saved', '', 'info')  
//  	}
// });

// // tentativa 2
// const swalWithBootstrapButtons = Swal.mixin({
//   customClass: {
//     confirmButton: 'btn btn-success',
//     cancelButton: 'btn btn-danger'
//   },
//   buttonsStyling: false
// })

// swalWithBootstrapButtons.fire({
//   title: 'Sessão ou login expirado',
//   text: "Digite a senha para logar novamente",
//   input: 'password',
//   inputAttributes: {
//     autocapitalize: 'off'
//   },
//   showCancelButton: true,
//   confirmButtonText: 'Logar',
//   cancelButtonText: 'Fechar',
//   reverseButtons: true,
//   inputValidator: (value) => {
//     if (!value) {
//       return 'You need to write something!'
//     }
//   }
// }).then((result) => {
//   // console.log(password)
//   if (result.isConfirmed) {
//     swalWithBootstrapButtons.fire(
//       'Login efetuado com sucesso!',
//       '',
//       'success'
//     )
//   } else if (
//     /* Read more about handling dismissals below */
//     result.dismiss === Swal.DismissReason.cancel
//   ) {
//     swalWithBootstrapButtons.fire(
//       'Erro no login!',
//       'Por favor, refaça o seu login.',
//       'error'
//     )
//   }
// })

// exemplo 3
// const { value: password } = await Swal.fire({
//   title: 'Sessão ou login expirado',
//   text: "Digite a senha para logar novamente",
//   html:'Usuário <b>'+form.usuario+'</b>.<br> Digite a senha para logar novamente.',
//   input: 'password',
//   inputLabel: 'Password',
//   inputPlaceholder: 'Digite sua senha',
//   inputAttributes: {
//     maxlength: 10,
//     autocapitalize: 'off',
//     autocorrect: 'off'
//   },
//   confirmButtonText: 'Logar',
//   inputValidator: (value) => {
//     if (!value) {
//       return 'Senha inválida!'
//     }else{
//       form.senha = value
//       return logar()
//     }
//   }

// })

// if (password) {
//   Swal.fire('Login efetuado com sucesso!', '','success')
// }



}


export default AlertaLogin
